import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'auth-layout',
    standalone: true,
    imports: [RouterModule],
    templateUrl: './app.authlayout.html'
})
/* v8 ignore start */
export class AuthLayout {}
/* v8 ignore stop */
